import { Box, FormHelperText } from '@mui/material';
import ColorPicker from '../../../../../components/ColorPicker';
import { CustomTextField } from '../../../../../components/CustomTextField';
import DefineAreaStepApp from '../Functionality/DefineAreaStepApp';
import { CleanIcon, IconPencilIndicator, IconSquareIndicator } from '../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import { MapContainer, TileLayer, FeatureGroup } from 'react-leaflet';
import 'leaflet.fullscreen';
import 'leaflet.fullscreen/dist/Control.FullScreen.css';

import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { DRAW_MODE } from '../Model/Model';
import GeofencesMap from './GeofencesMap';
import React from 'react';
import { CustomStyleFormHelperText } from '../../../../../components/Styles';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const DefineAreaStep = ({
    geofences,
    setGeofences,
    latitude,
    setLatitude,
    longitude,
    setLongitude,
    item,
    setItem,
    center,
    disabled,
    emptyFields,
    t,
}) => {
    const {
        drawMode,
        setDrawMode,
        mapType,
        tileUrls,
        featureGroupRef,
        DrawHandler,
        hasShapes,
        handleChange,
        cleanMap,
    } = DefineAreaStepApp({
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        item,
        setItem,
        setGeofences,
    });

    return (
        <>
            <div
                className={`w-100 h-100 border-radius-8px ${emptyFields ? 'border-full-error-code-600' : 'border-full-shades-100'}`}
            >
                {disabled ? (
                    <>
                        {center && (
                            <GeofencesMap
                                center={center}
                                geofences={geofences}
                                geofenceTitle='defined_areas'
                                showTitle={false}
                                classNameMap={'h-500px'}
                            />
                        )}
                    </>
                ) : (
                    <>
                        <div className='row align-items-start justify-content-center mt-4'>
                            <div className='col-2 d-flex align-items-start justify-content-end gap-3 ms-0 me-0 '>
                                <ButtonIcon
                                    id='btn_das_selector_edit'
                                    className={`h-40px w-40px ${drawMode === DRAW_MODE.RECTANGLE ? 'btn-outlined-secondary-600-100 ' : 'btn-outlined-secondary-600-00 '}`}
                                    iconProps={'icon-color-secondary-600 h-24px w-24px'}
                                    Icon={IconSquareIndicator}
                                    onClick={() => {
                                        setDrawMode(drawMode === DRAW_MODE.RECTANGLE ? null : DRAW_MODE.RECTANGLE);
                                        cleanMap();
                                    }}
                                />
                                <ButtonIcon
                                    id='btn_das_selector'
                                    Icon={IconPencilIndicator}
                                    iconProps={'icon-color-secondary-600 h-24px w-24px'}
                                    className={`h-40px w-40px  ${drawMode === DRAW_MODE.POLYGON ? 'btn-outlined-secondary-600-100 ' : 'btn-outlined-secondary-600-00 '}`}
                                    onClick={() => {
                                        setDrawMode(drawMode === DRAW_MODE.POLYGON ? null : DRAW_MODE.POLYGON);
                                        cleanMap();
                                    }}
                                />
                                <div className='vertical-separator-shades-950 me-0 h-28px mt-2' />
                            </div>
                            <Box className='col-12 col-md-3 '>
                                <ColorPicker
                                    id='clp_das_stroke_color'
                                    title='stroke_color'
                                    name='strokeColor'
                                    preview={false}
                                    color={item.strokeColor}
                                    onChange={handleChange}
                                />
                            </Box>
                            <Box className='col-12 col-md-3'>
                                <ColorPicker
                                    id='clp_das_fill_color'
                                    title='fill_color'
                                    name='fillColor'
                                    preview={false}
                                    color={item.fillColor}
                                    onChange={handleChange}
                                />
                            </Box>

                            <Box className='col-12 col-md-3 d-flex align-items-center ms-0 me-0'>
                                <div className='vertical-separator-shades-950 me-4 h-28px mt-2' />
                                <CustomTextField
                                    id='txt_das_stroke_width'
                                    name='strokeWidth'
                                    trans='stroke_width'
                                    type='number'
                                    required={true}
                                    value={item.strokeWidth}
                                    onChange={handleChange}
                                    length={2}
                                />
                            </Box>
                        </div>

                        {center && (
                            <MapContainer
                                center={center}
                                zoom={10}
                                className='w-100 h-500px z-index-0 border-radius-bottom'
                                fullscreenControl={true}
                            >
                                <TileLayer key={mapType} url={tileUrls[mapType]} />

                                <FeatureGroup ref={featureGroupRef} />

                                <DrawHandler
                                    geofences={geofences}
                                    setGeofences={setGeofences}
                                    drawMode={drawMode}
                                    featureGroupRef={featureGroupRef}
                                    setDrawMode={setDrawMode}
                                    handleChange={handleChange}
                                    setLatitude={setLatitude}
                                    setLongitude={setLongitude}
                                    itemData={item}
                                />

                                {hasShapes && (
                                    <div className='position-absolute bottom-0 start-50 translate-middle-x mb-3 z-index-1000'>
                                        <ButtonAction
                                            id='btn_das_clear_map'
                                            name='clear_map'
                                            className={'background-shades-900 font-color-shades-100'}
                                            disabled={false}
                                            splitName={false}
                                            extraClassName={''}
                                            Icon={CleanIcon}
                                            onClick={() => cleanMap()}
                                        />
                                    </div>
                                )}
                            </MapContainer>
                        )}
                    </>
                )}
            </div>{' '}
            <div className={'col-12 px-0 mx-0 mt-1'}>
                <FormHelperText error={true} sx={CustomStyleFormHelperText(false)}>
                    {emptyFields && t('geofence_required_area')}
                </FormHelperText>
            </div>
        </>
    );
};

export default DefineAreaStep;
